import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { ChatService } from '../../../services/in-app-services/chat.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  chatService = inject(ChatService);
  platform = inject(Platform);
  
  isMobile = this.platform.is('ios') || this.platform.is('android');

  constructor() {}

  ngOnInit() {}

  goToSettings() {
    this.router.navigate(['/profile']);
  }

  openChat() {
    this.chatService.openChat();
  }
}
